export default "__VITE_ASSET__BI0Eb3VJ__"